import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireFeatureGate } from '~/utils/guards';

export const Route = createFileRoute('/_authenticated/_tenant/trial')({
  beforeLoad: requireFeatureGate('trial_flow'),
  component: () => <Outlet />,
});
